import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=63ea22d6&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=ts"
export * from "./Folder.vue?vue&type=script&lang=ts"
import style0 from "./Folder.vue?vue&type=style&index=0&id=63ea22d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ea22d6",
  null
  
)

export default component.exports